<template>
    <div id="firstpartbg" class="firstpartbg">
        <toolbox 
            v-for="(eachtext, index) in text"
            :key="index"
            :eachtext="eachtext"
            :hint="'white'"
        >
        </toolbox>
    </div>
</template>

<script>
    
    import toolbox from '@/components/common/toolbox.vue'
    export default {
        
        data(){
            return{
                
            }
        },
        props: {
            text: { type: Array },
        },
        mounted(){
            
        },
        components: {
            toolbox
        },
        methods:{
        },
    }
</script>

<style lang="scss" scoped>
.firstpartbg{
    position: relative;
    width: 100%;
    padding-top: 60px;
    padding-bottom: 60px;
    background-color: #FAFAFA;
    @media (min-width: 768px) {
        padding-top: 80px;
        padding-bottom: 80px;
    }
    div + div {
        padding-top: 43px;
        @media (min-width: 768px) {
            padding-top: 40px;
        }
    }
}
</style>